import React, { useState } from "react";
import ModalSkeleton from "./ModalSkeleton";
import { Row, Col, Modal, Button } from "react-bootstrap";
import "../assets/styles/addContractDetailsModal.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { useHistory } from "react-router-dom";

function AddContractTyprModal({ 
  open, 
  setOpen,
  contractType,
  setContractType,
  setAllFieldsCompleted
 }) {
  const [isValue , setValue] = useState("template")

  const  modalstate = ()=>{
    setContractType(isValue) ;
  }
  return (
    <ModalSkeleton
      open={open}
      setOpen={setOpen}
      title={"Select Contract Type"}
      size={"md"}
    >
      <div className="add-contract-details-modal">
        <Row>
          <Col md={12}>
            
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label"><h5></h5></FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                value={isValue}
                
                   onChange={(e)=>setValue(e.target.value)}
                
                  
              >
                <div className="ownData-modal">
                <FormControlLabel
                  value={"template"}
                  control={<Radio sx={{
                    color: '#92d828',
                    '&.Mui-checked': {
                      color: '#92d828',
                    },
                  }} />}
                  label="Template"
                  
                />
                <FormControlLabel
                  color="#92d828"
                  control={<Radio sx={{
                    color: '#92d828',
                    '&.Mui-checked': {
                      color: '#92d828',
                    },
                  }} />}
                  label="Own Data"
                  value={"ownData"}
                />
                 </div>
              </RadioGroup>
            </FormControl>
           

          </Col>
        </Row>
      </div>
      <Modal.Footer>
        <Button className="ownData_btn"
          variant="primary"
          onClick={() => {
            modalstate();
            setAllFieldsCompleted(true);
            setOpen(false);
            
          }}
        >
          Create
        </Button>
      </Modal.Footer>
    </ModalSkeleton>
  );
}

export default AddContractTyprModal;
